/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ResourceJoinType {
    PublicResidential = 'PUBLIC_RESIDENTIAL',
    ResidentialPublic = 'RESIDENTIAL_PUBLIC'
}

export function ResourceJoinTypeFromJSON(json: any): ResourceJoinType {
    return ResourceJoinTypeFromJSONTyped(json, false);
}

export function ResourceJoinTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourceJoinType {
    return json as ResourceJoinType;
}

export function ResourceJoinTypeToJSON(value?: ResourceJoinType | null): any {
    return value as any;
}

